export default __webpack_public_path__ + "static/applet-17-set-1-a8b73f3252d6e7e619ccd5a0072ca90d.webp";